import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import DocumentMeta from 'react-document-meta';
import * as authActions from 'redux/modules/auth';
import {actions as formActions} from 'reactis-forms';
import {getWindowSize} from '../../utils/utils';
import immutable from 'immutable';
import {TextInput, RxForm, Checkbox, FormField} from 'reactis-forms';
import {bindActionCreators} from 'redux';

@connect(
	state => ({user: state.auth.user, error: state.auth.loginError}),
	(dispatch) => {
		return {
			authActions: bindActionCreators(authActions, dispatch),
			formActions: bindActionCreators(formActions, dispatch)
		};
	}
)
export default class Login extends Component {

	static contextTypes= {
		router: React.PropTypes.object,
		user: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);
		this.state = {
			error: false
		};
		this.schema = {
			username: {
				class: TextInput,
				autoFocus: 300,
				label: 'Login',
				type: 'email',
				placeholder: 'E-mail',
				className: 'form-control',
				rules: {
					presence: {message: 'Zadejte přihlašovací jméno!'}
				}
			},
			password: {
				class: TextInput,
				type: 'password',
				placeholder: 'Heslo',
				className: 'form-control password',
				label: 'Heslo',
				rules: {
					presence: {message: 'Zadejte heslo!'}
				}
			},
			remember: {
				class: Checkbox,
				value: true,
				className: "styled"
			}
		};
	}

	componentWillMount() {
		if (this.props.user) {
			this.context.router.replace('/');
		}
	}

	handleSubmit(form) {
		const values = form.getValues().toJS();
		this.props.authActions.login(values).then((result) => {
			if (!result.error) {
				this.props.formActions.setValue('login', immutable.Map());
				//window.XAuth = action.result.token;
			}
		});
	}

	handleLost(e) {
		e.preventDefault();
		this.props.onLostPassword();
	}

	handleFbClick() {
		window.location = '/oauth/fb';
	}

	render() {

		return (
			<div className="">
			<RxForm id="login" schema={this.schema} className="form-login" onSubmit={this.handleSubmit.bind(this)}>
						<div className="text-center">
							<h5 className="content-group">Přihlášení
								<small className="display-block">Zadejte e-mail a heslo.</small>
							</h5>
						</div>

						{this.props.error && <div className="errorHandler alert alert-danger">
							{this.props.error}
						</div>}

						<div className="form-group has-feedback has-feedback-left">
								<FormField name="username"/>

								<div className="form-control-feedback">
									<i className="icon-user text-muted"></i>
								</div>
						</div>

						<div className="form-group has-feedback has-feedback-left">
							<FormField name="password"/>
								<div className="form-control-feedback">
									<i className="icon-lock2 text-muted"></i>
								</div>
						</div>


						{!__MOBILE__ && <div className="form-group login-options">
							<div className="row">
								<div className="col-sm-12">
									<label className="checkbox-inline">
										<FormField name="remember"/>
										Pamatovat přihlášení
									</label>
								</div>
							</div>
						</div>}

						<div className="form-group">
							<button type="submit" className="btn bg-blue btn-block">Přihlásit <i className="icon-arrow-right14 position-right"></i></button>
						</div>

						{false && <div>
							<p className="login-line"><span>nebo</span></p>
							<div className="form-group">
								<button onClick={() => this.handleFbClick()} type="submit" className="btn bg-blue btn-block"><i className="fa fa-facebook position-left"></i>Přihlásit přes Facebook</button>
							</div>
						</div>}

					<div className="text-right">
						<a href="#" onClick={(e) => this.handleLost(e)}>Zapomenuté heslo?</a>
					</div>
			</RxForm>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Login/LoginForm.js